package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings

private const val KEY_REMINDERS_ENABLED = "notif_reminders_enabled"
private const val KEY_OPEN_HISTORY = "notif_open_history"
private const val KEY_OS_PERMISSION_REQUESTED = "notif_os_permission_requested"
private const val KEY_SOFT_ASK_COUNT = "notif_soft_ask_count"
private const val KEY_LAST_SOFT_ASK_EPOCH_DAY = "notif_last_soft_ask_epoch_day"
private const val KEY_LAST_SCHEDULED_VARIANT = "notif_last_scheduled_variant"
private const val KEY_LAST_SCHEDULED_HOUR = "notif_last_scheduled_hour"

class SettingsNotificationPrefsStore(
    private val settings: Settings,
) : NotificationPrefsStore {

    override fun remindersEnabledByUser(): Boolean = settings.getBoolean(KEY_REMINDERS_ENABLED, true)

    override fun setRemindersEnabledByUser(enabled: Boolean) {
        settings.putBoolean(KEY_REMINDERS_ENABLED, enabled)
    }

    override fun recordAppOpen(minuteOfDayLocal: Int, windowSize: Int) {
        val updated = (openTimeHistory() + minuteOfDayLocal).takeLast(windowSize.coerceAtLeast(1))
        settings.putString(KEY_OPEN_HISTORY, updated.joinToString(","))
    }

    override fun openTimeHistory(): List<Int> {
        val raw = settings.getStringOrNull(KEY_OPEN_HISTORY) ?: return emptyList()
        return raw.split(",").mapNotNull { it.toIntOrNull() }
    }

    override fun hasRequestedOsPermission(): Boolean = settings.getBoolean(KEY_OS_PERMISSION_REQUESTED, false)

    override fun markOsPermissionRequested() {
        settings.putBoolean(KEY_OS_PERMISSION_REQUESTED, true)
    }

    override fun softAskCount(): Int = settings.getInt(KEY_SOFT_ASK_COUNT, 0)

    override fun lastSoftAskEpochDay(): Long? = settings.getLongOrNull(KEY_LAST_SOFT_ASK_EPOCH_DAY)

    override fun recordSoftAskShown(epochDay: Long) {
        settings.putInt(KEY_SOFT_ASK_COUNT, softAskCount() + 1)
        settings.putLong(KEY_LAST_SOFT_ASK_EPOCH_DAY, epochDay)
    }

    override fun lastScheduledVariant(): String? = settings.getStringOrNull(KEY_LAST_SCHEDULED_VARIANT)

    override fun lastScheduledHour(): Int? = settings.getIntOrNull(KEY_LAST_SCHEDULED_HOUR)

    override fun recordScheduled(variant: String, hour: Int) {
        settings.putString(KEY_LAST_SCHEDULED_VARIANT, variant)
        settings.putInt(KEY_LAST_SCHEDULED_HOUR, hour)
    }

    override fun resetAll() {
        settings.remove(KEY_REMINDERS_ENABLED)
        settings.remove(KEY_OPEN_HISTORY)
        settings.remove(KEY_OS_PERMISSION_REQUESTED)
        settings.remove(KEY_SOFT_ASK_COUNT)
        settings.remove(KEY_LAST_SOFT_ASK_EPOCH_DAY)
        settings.remove(KEY_LAST_SCHEDULED_VARIANT)
        settings.remove(KEY_LAST_SCHEDULED_HOUR)
    }
}
